
// Test data for Level 1 Bunker Training

export const bunkerTests = [
  {
    id: "bunker-court",
    title: "Bunkers court",
    description: "Autour d'un trou, sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez à l'aide de tees 3 cercles de 0.5, 1, 2 m. Placer sa balle dans un bunker de green, taper 10 balles depuis les distances G=5, H=8, I=12 m et compter les points selon le cercle d'arrivée.",
    icon: "🏖️"
  },
  {
    id: "bunker-long",
    title: "Bunker long",
    description: "Autour d'un trou, sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez à l'aide de tees 3 cercles de 0.5, 1, 2 m. Placer sa balle dans un bunker de green, taper 10 balles depuis les distances G1=15, H1=20 m et compter les points selon le cercle d'arrivée.",
    icon: "🏝️"
  }
];

